import React from "react";
import { Provider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import store from "../stores/reduxStore";
import { ThemeProvider } from "styled-components";
import { apolloClient } from "js/apollo/apollo-client";
import { AuthProvider } from "frontend/hooks/useAuth";
import AuthModal from "frontend/components/auth/AuthModal";
import SiteHeaderProvider from "core/SiteHeader/context/SiteHeaderProvider";
import SiteHeader from "core/SiteHeader";

import { CurrentUserContextProvider } from "contexts/CurrentUserContext";

import theme from "../themes/theme";

import { DevicesProvider } from "frontend/context/DevicesContext/index.js";
import { BannersProvider } from "frontend/context/BannersContext";
import { CookieConsentProvider } from "frontend/context/CookieConsentContext";

const NounProjectHeaderParent = () => {
    return (
        <ThemeProvider theme={theme}>
            <ApolloProvider client={apolloClient}>
                <Provider store={store}>
                    <DevicesProvider>
                        <BannersProvider>
                            <CookieConsentProvider>
                                <CurrentUserContextProvider>
                                    <AuthProvider>
                                        <SiteHeaderProvider isLegacyPage>
                                            <SiteHeader />
                                        </SiteHeaderProvider>
                                        <AuthModal />
                                    </AuthProvider>
                                </CurrentUserContextProvider>
                            </CookieConsentProvider>
                        </BannersProvider>
                    </DevicesProvider>
                </Provider>
            </ApolloProvider>
        </ThemeProvider>
    );
};

export default NounProjectHeaderParent;
